import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss']
})
export class RegionComponent implements OnInit {
  MileleLogoPath: string  = `${environment.hRef}assets/Milele_logo_white.png`;
  logoPath: string  = `${environment.hRef}assets/logo_w.png`;
  powerdByText: string = 'Powered by ICEA LION Group. All rights reserved.';

  session: string | null = null;
  regionType: 0 | 1 = 0;


  constructor (
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly notificationService: NotificationService,
    private readonly tabControlService: TabControlService,
    private readonly estateControlService: EstateControlService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      try {
        if (params["session"] != undefined) {
          this.session = params["session"];
        }
      } catch (error) {
        console.error('Session Resume error! ', error);
      }
    });
  }
  
  get nextRoute(): string | null {
    return this.notificationService.nextRoute;
  }

  onRegionChange(value: boolean): void {
    this.regionType = value ? 0 : 1;
  }

  navHome(): void {
    const nextPage = ``;
    if (this.session == '') {this.router.navigate([nextPage]);}
    else {this.router.navigate([nextPage], {queryParams: {session: this.session}});}
  }

  submitRegionSelection(): void {
    if (!this.nextRoute) return;
    // Update region on the respective service based on the next route
    if (this.nextRoute.includes('trust-fund')){
      this.tabControlService.regionType = this.regionType;
      this.tabControlService.OTPMessage = this.regionType === 1 ? this.tabControlService.diasporaOTPMessage : this.tabControlService.defaultOTPMessage;
      this.tabControlService.updateRecord(0);
    } else{
      this.estateControlService.regionType = this.regionType;
      this.estateControlService.OTPMessage = this.regionType === 1 ? this.estateControlService.diasporaOTPMessage : this.estateControlService.defaultOTPMessage;
      if (this.estateControlService.planType === 0) {
        this.estateControlService.updateRecord(0);
      } else {
        this.estateControlService.updateRecordWill(0);
      }
    }
    if (this.session == '') {this.router.navigate([this.nextRoute]);}
    else {this.router.navigate([this.nextRoute], {queryParams: {session: this.session}});}
  }
}
